module.exports = __webpack_public_path__ + "img/Sarah.4f1ca710.png";